<template>
<div class="z-main">
 	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('意见反馈')}}</div>
		<div></div>
	</header>
<div class="z-body">
	<section style="text-align: center;font-size: 16px;margin-top: 12px;">
	  <textarea v-model="feedbackContent" :placeholder="$t('请输入')+' '+$t('内容')" style="width: 88%;color: #fff;height: 200px;padding: 10px;border: 1px solid #eae0e0;"></textarea>
	</section>
	<section style="text-align: center">
	  <div @click="sendFeedback"  class="common-btn">{{$t('提交')}}</div>
	</section>
	<!-- <section>
	  <div style="font-size: 16px;color: lightgray;border-bottom: none;padding: 14px;">我的意见反馈</div>
	  <section class="finan">
		<load-more :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :bottomPullText='bottomText' :auto-fill="false" @bottom-status-change="handleBottomChange" ref="loadmore">
		  <section style="background-color: #424355;">
			<div style="border-bottom: 1px solid rgba(0,0,0,0.6);" v-for="item in dataList">
			  <div style="display: flex;justify-content: space-between;padding: 10px;">
				<div style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;width: 50%;">{{item.question}}</div>
				<div style="width: 40%;text-align: right">{{item.atime}}</div>
			  </div>
			  <div style="display: flex;justify-content: space-between;padding: 10px;">
				<div style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;width: 80%;line-height: 35px">{{item.answer==""? "还未回复" : item.answer}}</div>
				<div>
				  <div @click="deleteData(item.id)" style="background-color:rgb(207,68,63);padding: 8px;border-radius: 4px">
					删除
				  </div>
				</div>
			  </div>
			</div>
		  </section>
		</load-more>
	  </section>
	</section> -->
  </div>
 </div>
</template>

<script>
	import loadMore from "../../components/loadMore.vue"
	export default {
	  inject:["reload"],
	  name: 'feedbackFeedback',
	  data() {
		return {
		  feedbackContent: "",
		  nowPage: 1,
		  pagesize: 0,
		  total: 0,
		  dataList: [],
		  scrollHeight: 0,
		  scrollTop: 0,
		  containerHeight: 0,
		  loading: false,
		  allLoaded: false,
		  bottomText: this.$t('上拉加载更多')+'...',
		  bottomStatus: '',
		  totalCount: ''
		}
	  },
	  mounted() {
		this.get('api/Feedback/Lists.html', {
		  page: 1
		}).then((res) => {

		  if (res.code == 0) {
			this.dataList = res.data.data
			this.nowPage = res.data.page
			this.total = res.data.total
			this.pagesize = res.data.pagesize
		  }
		})
	  },
	  methods: {
		sendFeedback: function () {
		  let _this=this
		  if (this.feedbackContent == "") {
		  	this.$store.commit('layer',this.$t('发送内容不能为空'))
		  }else {
			this.post('api/Feedback/Add.html', {
			  content: this.feedbackContent
			}).then((res) => {

			  if (res.code == 0) {
			  	this.$store.commit('layer',res.msg)
				setTimeout(function () {
				  _this.reload()
				},1500)
			  }
			})
		  }
		},
		_scroll: function (ev) {
		  ev = ev || event;
		  this.scrollHeight = this.$refs.innerScroll.scrollHeight;
		  this.scrollTop = this.$refs.innerScroll.scrollTop;
		  this.containerHeight = this.$refs.innerScroll.offsetHeight;
		},
		loadBottom: function () {
		  let _this = this;
		  this.$store.commit('layer',this.$t('数据加载中'))
		  if (this.total == this.dataList.length) {
			// 当allLoaded = true时上拉加载停止
			this.loading = false;
			this.allLoaded = true;
			setTimeout(function () {
				this.$store.commit('layer',this.$t('暂无数据'))
			}, 1000)
		  } else {
			this.get('api/Feedback/Lists.html', {
			  page: this.nowPage + 1
			}).then((res) => {

			  setTimeout(function () {
				if (res.code == 0) {
				  _this.nowPage = res.data.page
				  for (let i = 0; i < res.data.data.length; i++) {
					_this.dataList.push(res.data.data[i])
				  }
				  this.$store.commit('layer',this.$t('加载完成'))
				} else {
					this.$store.commit('layer',this.$t('加载失败'))
				}
			  }, 1000)
			})
		  }
		},
		handleBottomChange(status) {
		  this.bottomStatus = status;
		},
		refresh:function () {
		  this.reload()
		},
		deleteData:function (dataId) {
		  let _this=this
		  this.post('api/Feedback/Del.html', {
			id: dataId
		  }).then((res) => {
			this.$store.commit('layer',res.msg)
			if(res.code==0){
			  setTimeout(function () {
				_this.reload()
			  },1500)
			}
		  })
		}
	  },
	  components:{
		'load-more': loadMore
	  }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/my/feedbackFeedback.vue